import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/evidence-slots'
)({
  staticData: { pageHeader: { title: 'Evidence Slots', pad: false } },
})
